import * as appUpdateTypes from './AppUpdateTypes';

const initialState = {
  appVersions: [],
  activeAppVersion: {},
  isVersionsLoading: false,
};

const appUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case appUpdateTypes.GET_APP_VERSIONS_PENDING: {
      return { ...state, isVersionsLoading: true, appVersions: [] };
    }
    case appUpdateTypes.GET_APP_VERSIONS_SUCCESS: {
      let activeAppVersion = action.data.find(item => item.isActive);
      return { ...state, isVersionsLoading: false, appVersions: action.data, activeAppVersion: activeAppVersion ? activeAppVersion : {} };
    }
    case appUpdateTypes.GET_APP_VERSIONS_FAILURE: {
      return { ...state, isVersionsLoading: false, appVersions: [] };
    }
    case appUpdateTypes.APP_UPDATE_RESET_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};

export { initialState };
export default appUpdateReducer;



// WEBPACK FOOTER //
// ./src/ui/features/AppUpdate/state/appUpdateReducer.js